import { createContext, useContext, useEffect, useState } from 'react';

const codeMap = {
  EG: '+20', SA: '+966', AE: '+971', KW: '+965', QA: '+974',
  BH: '+973', OM: '+968', JO: '+962', LB: '+961', GB: '+44', US: '+1',
};

const LocationContext = createContext({ countryCode: '+20' });

export const LocationProvider = ({ children }) => {
  const [countryCode, setCountryCode] = useState('+20');

  useEffect(() => {
    let cancelled = false;
    fetch('https://ipapi.co/json/')
      .then(r => r.json())
      .then(d => {
        if (!cancelled && codeMap[d.country_code]) {
          setCountryCode(codeMap[d.country_code]);
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <LocationContext.Provider value={{ countryCode }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation = () => useContext(LocationContext);